module.exports = __webpack_public_path__ + "media/club_product_v2/12-b3d51de7.webp";